import Head from "next/head";
import { useRouter } from "next/router";

const ORG_ADDRESS = {
    streetAddress: "325 S 1st St, Suite 120",
    addressLocality: "San Jose",
    addressRegion: "CA",
    postalCode: "95113",
    addressCountry: "US",
};

const ORG_PHONE = "+1-612-787-7533";

const ORG_GEO = {
    latitude: "37.3320",
    longitude: "-121.8898",
};

const organizationJsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Purple Door Finders",
    legalName: "Purple Door, LLC",
    url: "https://purpledoorfinders.com",
    logo: "https://purpledoorfinders.com/favicon.ico",
    address: {
        "@type": "PostalAddress",
        ...ORG_ADDRESS,
    },
    contactPoint: {
        "@type": "ContactPoint",
        telephone: ORG_PHONE,
        contactType: "customer service",
        areaServed: "US",
        availableLanguage: ["English"],
    },
    sameAs: [
        "https://instagram.com/purpledoorfinders",
        "https://facebook.com/purpledoorfinders",
        "https://twitter.com/findpurpledoor",
        "https://linkedin.com/company/purple-door-finders",
    ],
};

const Meta = ({ title, keywords, description, jsonLd, ogTitle, ogImage, ogType, robots }) => {
    const router = useRouter();
    const p = router.asPath.slice(1);
    let canonicalURL = `https://purpledoorfinders.com/${p}`.split("?")[0];

    if (canonicalURL.startsWith("https://purpledoorfinders.com/community-portal")) {
        canonicalURL = `https://portal.purpledoorfinders.com/${p}`.split("?")[0];
    }

    return (
        <Head>
            <meta charSet="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="keywords" content={keywords} />
            <meta name="description" content={description} />
            {robots ? <meta name="robots" content={robots} /> : null}

            {ogTitle ? <meta property="og:title" content={ogTitle} /> : null}
            {ogImage ? <meta property="og:image" content={ogImage} /> : null}
            {description ? <meta property="og:description" content={description} /> : null}
            {canonicalURL ? <meta property="og:url" content={canonicalURL} /> : null}
            {ogType ? <meta property="og:type" content={ogType} /> : null}

            {jsonLd ? <meta name="geo.region" content="US-CA" /> : null}
            {jsonLd ? (
                <meta name="geo.placename" content={ORG_ADDRESS.addressLocality} />
            ) : null}
            {jsonLd ? (
                <meta
                    name="geo.position"
                    content={`${ORG_GEO.latitude};${ORG_GEO.longitude}`}
                />
            ) : null}
            {jsonLd ? (
                <meta name="ICBM" content={`${ORG_GEO.latitude}, ${ORG_GEO.longitude}`} />
            ) : null}

            <link rel="icon" href="/favicon.ico" />
            <link rel="canonical" href={canonicalURL} />
            <title>{title}</title>
            {jsonLd ? (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
                />
            ) : (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(organizationJsonLd),
                    }}
                />
            )}
        </Head>
    );
};

Meta.defaultProps = {
    title: "Purple Door Finders",
    keywords: "",
    description: "Purple Door Finders",
};

export default Meta;
